
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 20 18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M1.563 8.105v.364a1 1 0 001 1h.343a1 1 0 011 1v5.03a1 1 0 001 1h10.656a1 1 0 001-1v-5.093c0-.518.42-.937.938-.937s.937-.42.937-.938v-.426a1 1 0 00-.414-.81l-7.438-5.372a1 1 0 00-1.17 0L1.976 7.294a1 1 0 00-.415.811z","stroke":"#fff","stroke-width":"1.5","stroke-linejoin":"round"}}),_c('rect',{attrs:{"x":"8.125","y":"10.875","width":"3.75","height":"5.625","rx":"1","stroke":"#fff","stroke-width":"1.5","stroke-linejoin":"round"}})])
          )
        }
      }
    